import { Colors } from '@zep-us/zus';
import { useTranslation } from 'next-i18next';
import type { MaterialDtoType } from '@/api/gen/_model/materialDtoType';
import { PaperFillIcon } from '@/icons';
import { TypeBadge } from '@/shared/components/QuizCardV2/TypeBadge';

/**
 * Material type badge component using generic TypeBadge
 * Shows material type (파일/유튜브/웹사이트) with icon
 * Reuses QuizCardV2's TypeBadge for consistency
 */
export const MaterialTypeBadge = ({
  type
}: {
  type: MaterialDtoType;
}) => {
  const {
    t
  } = useTranslation(['common']);
  const formattedType = (() => {
    switch (type) {
      case 'FILE':
        return t('common:learningMaterial.type.file');
      case 'WEB':
      case 'YOUTUBE':
      default:
        return '';
    }
  })();
  return <TypeBadge icon={<PaperFillIcon size="2xs" fill={Colors.Blue500} />} label={formattedType} data-sentry-element="TypeBadge" data-sentry-component="MaterialTypeBadge" data-sentry-source-file="MaterialTypeBadge.tsx" />;
};